<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Danh sách sản phẩm
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="col-sm-12 d-flex justify-content-center flex-wrap">
                        <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                            <span>{{error}}</span>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="col-sm-11 d-flex flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.product_name.label"
                                                :id="dataSearch.product_name.id"
                                                :placeholder="dataSearch.product_name.placeholder"
                                                :value-default="dataSearch.product_name.value"
                                                @inputValue="onChange($event, dataSearch.product_name.id)"
                                                :required="dataSearch.product_name.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.product_code.label"
                                                :id="dataSearch.product_code.id"
                                                :placeholder="dataSearch.product_code.placeholder"
                                                :value-default="dataSearch.product_code.value"
                                                @inputValue="onChange($event, dataSearch.product_code.id)"
                                                :required="dataSearch.product_code.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSearch" @click="searchProducts"></ButtonSearchComponent>
                            </div>
                        </div>

                    </div>
                    <div class="btn-invite-partner">
                        <ButtonAddComponent :width="'200px'" :label="labelButtonCreate" @click="redirectToCreate" ></ButtonAddComponent>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-between mt-4">
                        <div class="action d-flex align-items-center gap-3">
                            <div class="total">
                                {{ CommonText.TOTAL_RECORD(listProducts.length, paginate.itemCount) }}
                            </div>
                            <div class="dropdown-action">
                                <SelectCustom
                                    :label="selectAction.label"
                                    :id="selectAction.id"
                                    :placeholder="selectAction.placeholder"
                                    :value-default="selectAction.value"
                                    :required="selectAction.required"
                                    :options="selectAction.options"
                                    @action="actionSelect($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                        <div class="action-left d-flex align-items-center gap-3">
                            <ButtonAddComponent :width="'200px'" :label="labelButtonImport" @click="importProduct"></ButtonAddComponent>
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectLimitPage.label"
                                        :id="selectLimitPage.id"
                                        :placeholder="selectLimitPage.placeholder"
                                        :value-default="selectLimitPage.value"
                                        :required="selectLimitPage.required"
                                        :options="selectLimitPage.options"
                                        @action="actionLimitPage($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                    </div>
                    <div class="list-products-component">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 2%;"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                                    <th scope="col" v-for="(header, key) in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">
                                        {{header.label}}
                                        <span class="sort" v-if="header.sort !== undefined" @click="sortProducts(key)"><span><IconArrowDown :color="header.sort === 1 ? '#3a3a3a' : '#909090'"/></span><span style="margin-left: -10px;"><IconArrowUp :color="header.sort === 1 ? '#909090' : '#3a3a3a'"/></span></span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="listProducts.length > 0" v-for="product in listProducts" :key="product.id">
                                    <td><InputCheckboxOne :id="product.id" :value-default="checkItems[product.id]" @inputValue="onChangeSelectItem($event, product.id)" :checked="checkItems[product.id]"></InputCheckboxOne></td>
                                    <td class="product-name"><p @click="showProductDetail(product.id)">{{product.product_name}}</p></td>
                                    <td>{{product.product_code}}</td>
                                    <td>{{product.product_quantity}}</td>
                                    <td>{{CommonService.formatPrice(product.product_price, 'VND')}}</td>
                                    <td>{{CommonService.formatPrice(product.product_selling_price, 'VND')}}</td>
<!--                                    <td>{{product.product_unit}}</td>-->
                                    <td>{{product.product_tax + '%'}}</td>
                                    <td>{{product.warehouse?.name ?? ''}}</td>
                                </tr>
                                <tr v-else>
                                    <td colspan="9" class="text-center">Không có dữ lệu được tìm thấy!</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <PaginateComponent v-if="listProducts.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>
<ModalExportComponent
        @showModal="eventShowModalExport($event)"
        :eventClickShowModal="eventClickShowModalExport"
        :listItemSelected="listItemSelected"
        :location="location"
        :table="table"
></ModalExportComponent>
<ModalProductImportComponent
        @showModalProduct="showModalImportProduct($event)"
        @errorMessage="showErrorMessage($event)"
        :eventClickShowModal="eventClickShowModalImport"
        :listProductsSelected="listItemSelected"
></ModalProductImportComponent>
<LoadingComponent v-if="isLoading"></LoadingComponent>

